import { IconIdCardLight, skinVars } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import React from "react";
import { strings } from "../../../../localization";
import Feedback from "../../../../components/templates/Feedback";
import { useAnalytics, useNavigateCustom } from "../../../../hooks";
import { useLocation } from "react-router-dom";
import { DocumentosCopyBiometryAnalysisStatus } from "../../../../enum";

interface routeProps {
	statusDocumentosCopy?: DocumentosCopyBiometryAnalysisStatus;
}

const ValidateDocumentsHome: React.FC = observer(() => {
	const navigate = useNavigateCustom();
	const routeProps = useLocation().state as routeProps;
	const { title, description } = strings.pages.validateDocumentsHome;
	const { buttonPrimary } = strings.components.buttons;

	const { addAnalyticEvent, updatePageView } = useAnalytics();

	const onAction = React.useCallback(() => {
		addAnalyticEvent({
			component: "button",
			action: "click.button",
			step: "fgts:cadastro:enviar-documentos",
			event: "interaction",
			product: "fgts",
			description: buttonPrimary,
		}, { applySanitize: true });

		if (routeProps.statusDocumentosCopy && routeProps.statusDocumentosCopy === DocumentosCopyBiometryAnalysisStatus.APPROVED) {
			return navigate("/fintech-registration/validate-documents/approved");
		}

		navigate("/fraud-analysis");
	}, []);

	React.useEffect(() => {
		updatePageView({
			name: "Vivo Money Cadastro Enviar Documento",
			pagePath: "/cadastro-fgts/enviar-documento",
		});
	}, []);

	return (
		<Feedback
			screenResponsiveProps={{
				onBack: () => navigate(-1),
				navigationTitle: strings.pages.navigation.anticipation,
			}}
			heroDataInfoProps={{
				icon: <IconIdCardLight size={64} color={skinVars.colors.brand} />,
				title,
				description,
			}}
			buttonProps={{
				textButton: buttonPrimary,
				onAction,
			}}
		/>
	);
});

export default ValidateDocumentsHome;
